import { Image } from "@mantine/core";
// import { useMediaQuery } from "@mantine/hooks";
import { useContext } from "react";
import { Container } from "../..";
// import businessesOfferingsLogo from "../../../assets/svg//BusinessesOfferings.svg";
import { businessesOfferingsList } from "../../../utils/data";
import { ThemeContext } from "../../context";
import { JiffyContainer } from "../Testimonial/Testimonial.elements";
import {
  // ImageContainer,
  ListContainer,
  ListDescription,
  ListImageContainer,
  ListText,
  ListWrapper,
} from "./BusinessesOfferings.elements";

export const BusinessesOfferings = () => {
  const { rooTheme } = useContext(ThemeContext);
  // const matches = useMediaQuery("(max-width: 768px)");

  return (
    <Container className="px-0 py-10 xl:px-5 lg:py-8">
      <JiffyContainer>
        {/* <ImageContainer>
          <Image
            src={businessesOfferingsLogo}
            maw={matches ? "100%" : "50%"}
            mx="auto"
            fit="cover"
            alt="Jiffy Courier Get Started"
            withPlaceholder
          />
        </ImageContainer> */}
        <ListWrapper>
          {businessesOfferingsList.map((item: any, index: any) => {
            return (
              <ListContainer key={`key-${index}`}>
                <ListImageContainer rooTheme={rooTheme}>
                  <Image
                    src={rooTheme === "dark" ? item?.image : item?.imageDark}
                    width={25}
                    height={25}
                    fit="cover"
                    alt={`${item?.title}`}
                    withPlaceholder
                  />
                </ListImageContainer>
                <ListText rooTheme={rooTheme}>{item?.title}</ListText>
                <ListDescription rooTheme={rooTheme}>
                  {item?.description}
                </ListDescription>
              </ListContainer>
            );
          })}
        </ListWrapper>
      </JiffyContainer>
    </Container>
  );
};
